// extracted by mini-css-extract-plugin
export var container = "_3a-0";
export var error = "_3a-9";
export var label = "_3a-5";
export var light = "_3a-6";
export var md = "_3a-3";
export var sm = "_3a-2";
export var thin = "_3a-8";
export var thinBold = "_3a-7";
export var vertical = "_3a-4";
export var xs = "_3a-1";